import { API, authClient } from "../index";

// Generar pago en Redsys
export const generarPago = async (amount, orderId, cardNumber, expiryDate, cvc, nameCard, email, tipid, browserInfo, bizum = "", phoneNumber) => {
  return authClient().post(`${API}/pago/generar`, {
    amount,
    orderId,
    currency: "978", // Euros
    cardNumber,
    expiryDate,
    cvc,
    name: nameCard,
    email,
    tipid,
    browserInfo,
    bizum,
    phoneNumber
  });
};

// Validar respuesta de Redsys
export const validarPago = async (id) => {
  return authClient().get(`${API}/pago/estado/${id}`);
};

// Generar pago con Google Pay
export const generarPagoGooglePay = async (token, amount, tipid) => {
  return authClient().post(`${API}/pago/generarGooglePay`, {
    token,
    amount,
    currency: "978",
    tipid,
    metodoPago: "googlepay"
  });
};
